<!-- <ion-item class="summary-tab" button color="--ion-color-white" lines="none">
  <ion-label>
    <div class="summary-header dark-teal-2">Payment Summary</div>
  </ion-label>
</ion-item> -->

<div class="summary-header dark-teal-2 summary-header-box">Payment Summary</div>
<div class="payment-summary-container">
    <ion-card>
        <ion-card-content>
            <ion-list *ngIf="cartLength === 0" lines="none">
                <ion-item class="empty-cart-list">
                    <ion-label>
                        <ion-text>
                            <div class="ion-text-wrap empty-cart-text">You have no selected applications</div>
                        </ion-text>
                    </ion-label>
                </ion-item>
            </ion-list>
            <div *ngIf="cartLength > 0">
                <div *ngFor="let application of $paymentCart | async; let i = index; trackBy: trackByIndex">
                    <ion-list class="cart-list">
                        <ion-item class="cart-line-item">
                            <ion-grid>
                                <ion-row>
                                    <ion-grid>
                                        <ion-row>
                                            <ion-col>
                                                <h4 class="bold-text cart-display-payment-type">
                                                    {{ application?.displayPaymentType }}
                                                </h4>
                                            </ion-col>
                                        </ion-row>
                                        <ion-row>
                                            <ion-col size="7">
                                                <div>
                                                    <ion-text color="black">
                                                        {{ application?.program?.name }}
                                                    </ion-text>
                                                </div>
                                                <!-- <p>{{application?.location}}</p> -->
                                            </ion-col>
                                            <ion-col size="5" class="text-center">
                                                <h2 class="cart-display-payment-price" *ngIf="application?.paymentType !== 'final-payment'">
                                                    <span *ngIf="application?.paymentType === 'full-payment'">${{ application?.fullPaymentPrice }} USD</span>
                                                    <span *ngIf="application?.paymentType === 'first-payment'">${{ application?.firstPaymentPrice }} USD</span>
                                                </h2>
                                                <h2 class="cart-display-payment-price" *ngIf="application?.paymentType === 'final-payment'">
                                                    <span>
                                                        ${{ application?.finalPaymentPrice }}
                                                        USD
                                                    </span>
                                                </h2>
                                            </ion-col>
                                            <!-- <ion-col>
        
                    <ion-row *ngIf="application?.addons.length > 0">
                      <ion-label>Add-On(s):</ion-label>
                    </ion-row>
                    <ion-row class="text-center cart-display-payment-subtitle "
                      *ngFor="let addon of application?.addons; let i = index; trackBy: trackByIndex">
                      <ion-col>
                        {{addon?.name}}
                      </ion-col>
                      <ion-col>
                        +${{addon?.price}} USD
                      </ion-col>
                    </ion-row>
                    <ion-row *ngIf="application?.couponCodes[0]?.code">
                      <ion-label>Coupons:</ion-label>
                    </ion-row>
                    <ion-row class="text-center"
                      *ngFor="let coupon of application?.couponCodes; let i = index; trackBy: trackByIndex">
                      <ion-col>
                        <ion-badge>{{coupon?.code}}</ion-badge>
                      </ion-col>
                      <ion-col *ngIf="application?.couponCodes[0]?.code">
                        <ion-text>-{{coupon?.discount}} USD</ion-text>
                      </ion-col>
        
                    </ion-row>
        
                  </ion-col> -->
                                        </ion-row>
                                        <!-- malpractice -->
                                        <ion-row *ngIf="application?.malpracticeChecked || application?.switchProtectionChecked">
                                            <ion-col>
                                                <ion-text class="orange bold-text">Add-On:</ion-text>
                                            </ion-col>
                                        </ion-row>
                                        <ion-row *ngIf="application?.malpracticeChecked">
                                            <ion-col size="8" size-xs="7" size-sm="7">
                                                <ion-text> Malpractice Insurance </ion-text>
                                            </ion-col>
                                            <ion-col size="4" size-xs="5" size-sm="5">
                                                <ion-text class="item-sub-price">
                                                    + ${{ application?.malpracticeAddonPrice }}
                                                    USD
                                                </ion-text>
                                                <!-- <ion-col *ngFor="let addon of application?.paymentApplicationAddons; let i = index; trackBy: trackByIndex">
                      <ion-text>{{addon?.name}} - $ {{addon?.price}} USD</ion-text> -->
                                                <!-- late fee -->
                                            </ion-col>
                                        </ion-row>
                                        <ion-row *ngIf="application?.switchProtectionChecked">
                                            <ion-col size="8" size-xs="7" size-sm="7">
                                                <ion-text> Switch Protection </ion-text>
                                            </ion-col>
                                            <ion-col size="4" size-xs="5" size-sm="5">
                                                <ion-text class="item-sub-price">
                                                    + ${{ application?.switchProtectionAddonPrice }}
                                                    USD
                                                </ion-text>
                                                <!-- <ion-col *ngFor="let addon of application?.paymentApplicationAddons; let i = index; trackBy: trackByIndex">
                      <ion-text>{{addon?.name}} - $ {{addon?.price}} USD</ion-text> -->
                                                <!-- late fee -->
                                            </ion-col>
                                        </ion-row>
                                        <ion-row *ngIf="application?.isLate">
                                            <ion-col size="8" size-xs="7" size-sm="7">
                                                <ion-text color="danger">
                                                    Late Fee
                                                    <ion-icon
                                                        name="alert"
                                                        (click)="tooltip.toggle()"
                                                        #tooltip="matTooltip"
                                                        matTooltip
                                                        matTooltip="{{ (toolService.content | async)?.shared?.latefee }}"
                                                        matTooltipShowDelay="1"
                                                        color="danger"
                                                    ></ion-icon>
                                                </ion-text>
                                            </ion-col>
                                            <ion-col size="4" size-xs="5" size-sm="5" class="ion-text-center">
                                                <ion-text class="item-sub-price" color="danger"> + $200 USD </ion-text>
                                            </ion-col>
                                        </ion-row>
                                        <!-- <ion-row class="cart-display-payment-subtitle "
                    *ngFor="let addon of application?.addons; let i = index; trackBy: trackByIndex">
                    <ion-col size="7">
                      <ion-text>
                        {{addon?.name}}
                      </ion-text>
                    </ion-col>
                    <ion-col size="5">
                      <ion-text class="text-center">
                        +${{addon?.price}} USD
                      </ion-text>
                    </ion-col>
                    
                  </ion-row> -->
                                        <ion-row *ngIf="(application?.couponCodes)[0]?.code">
                                            <ion-text class="orange bold-text">Coupon:</ion-text>
                                        </ion-row>
                                        <ion-row *ngFor="let coupon of application?.couponCodes; let i = index; trackBy: trackByIndex">
                                            <ion-col size="8" size-xs="7" size-sm="7">
                                                <ion-row>
                                                    <ion-col size="12">
                                                        <ion-icon
                                                            *ngIf="!application?.activePriceDropCoupon"
                                                            (click)="deleteCoupon(application?.id, coupon?.code)"
                                                            name="trash"
                                                            size="small"
                                                            class="coupon-trash"
                                                        >
                                                        </ion-icon>
                                                        <ion-text color="{{ couponLabeler(coupon?.type, application?.paymentType, coupon?.bundleid) }}">
                                                            {{ coupon?.code
                                                            }}{{ couponMessageLabeler(coupon?.type, application?.paymentType, coupon?.bundleid) }}</ion-text
                                                        >
                                                    </ion-col>
                                                </ion-row>
                                            </ion-col>
                                            <ion-col size="4" size-xs="5" size-sm="5" *ngIf="(application?.couponCodes)[0]?.code">
                                                <ion-text
                                                    class="pull-right"
                                                    color="{{ couponLabeler(coupon?.type, application?.paymentType, coupon?.bundleid) }}"
                                                    >- ${{ coupon?.discount }} USD</ion-text
                                                >
                                            </ion-col>
                                        </ion-row>

                                        <!-- </ion-col> -->

                                        <!-- </ion-row> -->

                                        <!-- <ion-label slot="start">
        
              </ion-label>
              <ion-label slot="end">
                
              </ion-label> -->
                                    </ion-grid>
                                </ion-row>

                                <ion-row *ngIf="application?.partialPaymentDiscount > 0 || application?.voucherDiscount > 0">
                                    <ion-text class="orange bold-text">Previous Payment:</ion-text>
                                </ion-row>
                                <ion-row *ngFor="let payment of application?.previousPaymentList?.allPayments; let i = index; trackBy: trackByIndex">
                                    <ion-col size="8" size-xs="7" size-sm="7">
                                        <ion-text color="green">
                                            {{ payment?.type | date : 'longDate' : 'UTC' }}
                                        </ion-text>
                                    </ion-col>
                                    <ion-col size="4" size-xs="5" size-sm="5">
                                        <ion-text class="pull-right" color="green"> - ${{ payment?.total }} USD </ion-text>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-item>

                        <ion-item class="subtotal-container">
                            <ion-grid class="">
                                <ion-row>
                                    <ion-col size="8" size-xs="7" size-sm="7">
                                        <ion-text> Subtotal: </ion-text>
                                    </ion-col>
                                    <ion-col size="4" size-xs="5" size-sm="5">
                                        <ion-text class="bold-text">
                                            <h2 *ngIf="application?.paymentType === 'first-payment'">
                                                ${{
                                                    application?.firstSubtotalPrice +
                                                        application?.malpracticeAddonSubtotal +
                                                        application?.switchProtectionAddonSubtotal
                                                }}
                                                USD
                                            </h2>
                                            <h2 *ngIf="application?.paymentType === 'final-payment'">
                                                ${{ application?.finalSubtotalPrice + application?.malpracticeAddonSubtotal }}
                                                USD
                                            </h2>
                                            <h2 *ngIf="application?.paymentType === 'full-payment'">
                                                ${{
                                                    application?.fullSubtotalPrice +
                                                        application?.malpracticeAddonSubtotal +
                                                        application?.switchProtectionAddonSubtotal
                                                }}
                                                USD
                                            </h2>
                                        </ion-text>
                                        <!-- <ion-col *ngFor="let addon of application?.paymentApplicationAddons; let i = index; trackBy: trackByIndex">
                      <ion-text>{{addon?.name}} - $ {{addon?.price}} USD</ion-text> -->
                                    </ion-col>
                                </ion-row>
                                <!-- Due later -->
                                <ion-row *ngIf="application?.paymentType === 'first-payment'">
                                    <ion-col size="8" size-xs="7" size-sm="7">
                                        <ion-text>
                                            Due Later
                                            <!-- <ion-icon name="alert" (click)="tooltip.toggle()" #tooltip="matTooltip" matTooltip
                                                                        matTooltip="{{(toolService.content | async)?.shared?.latefee}}" matTooltipShowDelay="1"
                                                                        color="danger"></ion-icon> -->
                                        </ion-text>
                                    </ion-col>
                                    <ion-col size="4" size-xs="5" size-sm="5" class="ion-text-left">
                                        <ion-text class="item-sub-price">
                                            ${{ application?.finalSubtotalPrice }}
                                            USD
                                        </ion-text>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-item>
                    </ion-list>
                </div>
            </div>

            <!-- second non dynamic list for payment methods, coupons, total, checkout button -->
            <ion-list lines="none">
                <div class="coupon-wrapper">
                    <!-- copon component -->
                    <ion-item id="paymentDetailsSummaryHaveCouponBtn" type="button" (click)="openCouponModal()">
                        <ion-text color="secondary"><a class="have-coupon-anchor-text">Have a Coupon?</a></ion-text>
                    </ion-item>
                </div>
            </ion-list>
            <!-- payment methods -->
            <ion-list lines="none">
                <!-- payment methods component -->
                <ion-item>
                    <ion-text>Payment Type</ion-text>
                </ion-item>

                <!-- Segment with anchors -->
                <div class="ion-justify-content-center segment-payment-select">
                    <ion-segment (ionChange)="segmentChanged($event)" value="card">
                        <ion-row>
                            <ion-col>
                                <ion-segment-button
                                    id="paymentDetailsSummaryStripeCheckoutBtn"
                                    [ngClass]="{
                                        activeSegment: ($checkoutType | async) === 'card'
                                    }"
                                    value="card"
                                >
                                    <ion-row size="6">
                                        <ion-col>
                                            <ion-icon name="card"></ion-icon>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row size="6">
                                        <ion-col>
                                            <ion-text> Stripe Checkout </ion-text>
                                        </ion-col>
                                    </ion-row>
                                </ion-segment-button>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col>
                                <ion-segment-button
                                    id="paymentDetailsSummaryWireTrasferBtn"
                                    [ngClass]="{
                                        activeSegment: ($checkoutType | async) === 'wire'
                                    }"
                                    value="wire"
                                >
                                    <ion-row>
                                        <ion-col>
                                            <div>
                                                <fa-icon [icon]="faFileInvoiceDollar" size="lg"></fa-icon>
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <ion-text> Wire Transfer </ion-text>
                                        </ion-col>
                                    </ion-row>
                                </ion-segment-button>
                            </ion-col>
                        </ion-row>
                    </ion-segment>
                </div>
                <ion-row>
                    <ion-col>
                        <div *ngIf="($checkoutType | async) === 'card'">
                            <ion-text>
                                <p class="ion-text-center">Instant Payment with any of these payment methods:</p>
                            </ion-text>
                            <ion-img class="credit-card-image" [src]="'https://d6fj0ztu4j10m.cloudfront.net/svg/payment_images.svg'"> </ion-img>
                        </div>
                        <div *ngIf="($checkoutType | async) === 'wire'">
                            <ion-text>
                                <p class="ion-text-center">
                                    To complete a wire transfer, please contact
                                    <a href="mailto:advisors@amopportunities.org?subject=Wire Transfer" target="_blank" rel="noopener noreferrer"
                                        >advisors&#64;amopportunities.org</a
                                    >
                                </p>
                            </ion-text>
                            <!-- Wire transfers take on average 3-5 days to arrive. You will receive the wire transfer instructions after checkout to your
                                    email.  -->
                        </div>
                    </ion-col>
                </ion-row>
            </ion-list>
        </ion-card-content>
    </ion-card>

    <ion-card class="hidden-sm hidden-xs due-today-card">
        <div class="due-today-wrapper">
            <div class="due-today-title">Due Today:</div>
            <div *ngIf="$dueToday | async" class="due-today-price">${{ $dueToday | async }} USD</div>
        </div>
    </ion-card>
</div>
